import { createContext } from "react";

interface DataContextType {
    data: any[];
    loading: boolean;
    error: string | null;
    refetch: () => void;
}

export const DataContext = createContext<DataContextType | undefined>(undefined);